import {
  HealthDiaryPathsEnum,
  HealthDiaryRoutesEnum,
} from "@ch/router/HealthDiaryRoutes/enums.ts";
import BloodOxygenHistoryPageLazy from "@ch/pages/BloodOxygenPage/BloodOxygenHistoryPageLazy.tsx";
import BloodOxygenLogPageLazy from "@ch/pages/BloodOxygenPage/BloodOxygenLogPageLazy.tsx";
import BloodOxygenPageLazy from "@ch/pages/BloodOxygenPage";
import postHogFeatureFlagKeys from "@ch/helpers/utils/postHogAnalytics/postHogFeatureFlagKeys.ts";
import FeatureFlagRouteGate from "@ch/components/Gate/FeatureFlagRouteGate.tsx";

export const bloodOxygenRoutes = [
  {
    path: HealthDiaryPathsEnum.BLOOD_OXYGEN_HISTORY,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <BloodOxygenHistoryPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Blood Oxygen History",
      }),
      crumb: () => ({
        title: "Blood Oxygen History",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_BLOOD_OXYGEN_HISTORY,
      }),
    },
  },
  {
    path: HealthDiaryPathsEnum.BLOOD_OXYGEN_LOG,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <BloodOxygenLogPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Blood Oxygen Log",
      }),
      crumb: () => ({
        title: "Log Blood Oxygen",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_BLOOD_OXYGEN_LOG,
      }),
    },
  },
  {
    path: HealthDiaryPathsEnum.BLOOD_OXYGEN,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <BloodOxygenPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Blood Oxygen",
      }),
      crumb: () => ({
        title: "Blood Oxygen",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_BLOOD_OXYGEN,
      }),
    },
  },
];
